<template>
  <div class="part-two">
    <div class="title">
      <div style="font-size: 40px; color: #091221; font-weight: bold">
        聚焦企业数字化核心业务
      </div>
      <div class="title-min">
        为企业提供一站式数字化技术产品和营销服务
      </div>
    </div>
    <div class="main">
      <div class="main-item">
        <img :src="require('../assets/image_1/263.png')" />
        <div class="main-item-box">
          <div class="main-item-title">现成商业系统</div>
          <div class="main-item-btn">深度研发 购买即用</div>
          <div class="main-item-text">提供成熟稳定的模板系统，即装即用，缩短部署时间，满足企业基础运营需求。</div>
        </div>
      </div>
      <div class="main-item">
        <img :src="require('../assets/image_1/264.png')" />
        <div class="main-item-box">
          <div class="main-item-title">二次开发定制</div>
          <div class="main-item-btn">现有底层  灵活扩展</div>
          <div class="main-item-text">基于模板系统进行二次开发，适配企业个性化需求，实现功能与业务高度匹配。</div>
        </div>
      </div>
      <div class="main-item">
        <img :src="require('../assets/image_1/265.png')" />
        <div class="main-item-box">
          <div class="main-item-title">软件系统开发</div>
          <div class="main-item-btn">从零到一  定制开发</div>
          <div class="main-item-text">从零开始定制开发，完全根据企业需求设计，打造独一无二的软件系统。</div>
        </div>
      </div>
      <div class="main-item">
        <img :src="require('../assets/image_1/266.png')" />
        <div class="main-item-box">
          <div class="main-item-title">线上运营全案</div>
          <div class="main-item-btn">视觉升级  运营管理</div>
          <div class="main-item-text">专业运营团队提供代运营管理，降低企业运营成本，助力业务持续增长。</div>
        </div>
      </div>
      <div class="main-item">
        <img :src="require('../assets/image_1/267.png')" />
        <div class="main-item-box">
          <div class="main-item-title">供应链货盘赋能</div>
          <div class="main-item-btn">资源整合  货盘共享</div>
          <div class="main-item-text">对接优质供应链资源，帮助企业快速匹配供需，降低采购与库存成本。</div>
        </div>
      </div>
      <div class="main-item">
        <img :src="require('../assets/image_1/268.png')" />
        <div class="main-item-box">
          <div class="main-item-title">技术底层服务</div>
          <div class="main-item-btn">稳定护航  无忧运行</div>
          <div class="main-item-text">专业运维团队全程支持，确保系统安全稳定，让企业专注核心业务发展。</div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom">
      <div class="bottom-img"><img :src="currentPicture" alt="" /></div>
      <div class="tap">
        <div class="tap-item" @click="changeActive(1)">
          <div style="position: relative;left: 5px;" v-if="isActive == 1"><svg t="1692344373178"
              style="transform: rotate(89deg);" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="47573" width="20" height="20">
              <path
                d="M940.91599999 355.04l-346.22199999 490.345c-37.099 51.667-129.847 51.667-166.946 0L80.48699999 355.04c-37.099-51.667-10.497-137.063 63.70100001-137.063L878.25600001 217.977C952.45400001 217.977 978.016 303.373 940.91599999 355.04z"
                p-id="47574" fill="#203DF5"></path>
            </svg></div>
          <div
            style="padding:32px 22px 32px 28px;box-shadow: 0px 3px 10px 1px rgba(17,70,172,0.1);border-radius: 10px 10px 10px 10px;background: #FFFFFF;display: flex;width:226px"
            :class="{ 'is-actives': isActive == 1 }">
            <img src="../assets/part-two-logo1.png" alt="" v-if="isActive != 1" />
            <img src="../assets/part-two-logo1-active.png" alt="" v-else>
            <span style="font-size: 20px;color: #333333;margin-left: 10px;"
              :class="{ 'color-is-active': isActive == 1 }">智慧商城系统</span>
          </div>
        </div>
        <div class="tap-item" @click="changeActive(2)">
          <div style="position: relative;left: 5px;" v-if="isActive == 2"><svg t="1692344373178"
              style="transform: rotate(89deg);" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="47573" width="20" height="20">
              <path
                d="M940.91599999 355.04l-346.22199999 490.345c-37.099 51.667-129.847 51.667-166.946 0L80.48699999 355.04c-37.099-51.667-10.497-137.063 63.70100001-137.063L878.25600001 217.977C952.45400001 217.977 978.016 303.373 940.91599999 355.04z"
                p-id="47574" fill="#203DF5"></path>
            </svg></div>
          <div
            style="padding:32px 22px 32px 28px;box-shadow: 0px 3px 10px 1px rgba(17,70,172,0.1);border-radius: 10px 10px 10px 10px;background: #FFFFFF;display: flex;width:226px"
            :class="{ 'is-actives': isActive == 2 }">
            <img src="../assets/part-two-logo2.png" alt="" v-if="isActive != 2" />
            <img src="../assets/part-two-logo2-active.png" alt="" v-else>
            <span style="font-size: 20px;color: #333333;margin-left: 10px;"
              :class="{ 'color-is-active': isActive == 2 }">供应链中台系统</span>
          </div>
        </div>
        <div class="tap-item" @click="changeActive(3)">
          <div style="position: relative;left: 5px;" v-if="isActive == 3"><svg t="1692344373178"
              style="transform: rotate(89deg);" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="47573" width="20" height="20">
              <path
                d="M940.91599999 355.04l-346.22199999 490.345c-37.099 51.667-129.847 51.667-166.946 0L80.48699999 355.04c-37.099-51.667-10.497-137.063 63.70100001-137.063L878.25600001 217.977C952.45400001 217.977 978.016 303.373 940.91599999 355.04z"
                p-id="47574" fill="#203DF5"></path>
            </svg></div>
          <div
            style="padding:32px 22px 32px 28px;box-shadow: 0px 3px 10px 1px rgba(17,70,172,0.1);border-radius: 10px 10px 10px 10px;background: #FFFFFF;display: flex;width:226px"
            :class="{ 'is-actives': isActive == 3 }">
            <img src="../assets/part-two-logo3.png" alt="" v-if="isActive != 3" />
            <img src="../assets/part-two-logo3-active.png" alt="" v-else>
            <span style="font-size: 20px;color: #333333;margin-left: 10px;"
              :class="{ 'color-is-active': isActive == 3 }">服务商系统</span>
          </div>
        </div>
        <div class="tap-item" @click="changeActive(4)">
          <div style="position: relative;left: 5px;" v-if="isActive == 4"><svg t="1692344373178"
              style="transform: rotate(89deg);" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="47573" width="20" height="20">
              <path
                d="M940.91599999 355.04l-346.22199999 490.345c-37.099 51.667-129.847 51.667-166.946 0L80.48699999 355.04c-37.099-51.667-10.497-137.063 63.70100001-137.063L878.25600001 217.977C952.45400001 217.977 978.016 303.373 940.91599999 355.04z"
                p-id="47574" fill="#203DF5"></path>
            </svg></div>
          <div
            style="padding:32px 22px 32px 28px;box-shadow: 0px 3px 10px 1px rgba(17,70,172,0.1);border-radius: 10px 10px 10px 10px;background: #FFFFFF;display: flex;width:226px"
            :class="{ 'is-actives': isActive == 4 }">
            <img src="../assets/part-two-logo4.png" alt="" v-if="isActive != 4" />
            <img src="../assets/part-two-logo4-active.png" alt="" v-else>
            <span style="font-size: 20px;color: #333333;margin-left: 10px;"
              :class="{ 'color-is-active': isActive == 4 }">定制开发服务</span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      picture1: require("../assets/part-two1.jpg"),
      picture2: require("../assets/part-two2.jpg"),
      picture3: require("../assets/part-two3.jpg"),
      picture4: require("../assets/part-two4.jpg"),
      currentPicture: require("../assets/part-two1.jpg"),
      isActive: 1
    };
  },

  methods: {
    changeActive(index) {
      this.isActive = index
      if (index == 1) {
        this.currentPicture = this.picture1
      } else if (index == 2) {
        this.currentPicture = this.picture2
      } else if (index == 3) {
        this.currentPicture = this.picture3
      } else {
        this.currentPicture = this.picture4
      }
    }
  },

  components: {},
};
</script>
<style scope>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* 创建三列 */
  grid-template-rows: repeat(3, auto);
  /* 创建三行，高度根据内容自动调整 */
  gap: 20px;
  /* 可选：设置项目之间的间距 */
}

.main-item {
  position: relative;
  width: 380px;
  height: 384px;
  background: linear-gradient(31deg, #EFF8FF 0%, #FFFFFF 100%);
  border-radius: 8px 8px 8px 8px;
  margin-bottom: 30px;
}

.main-item-btn {
  width: 208px;
  cursor: pointer;
  padding: 8px 4px;
  background: #F3FAFF;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #007EFF;
  margin: 29px 0;
  font-weight: 400;
  font-size: 20px;
  color: #007EFF;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.main-item-text {
  font-weight: 400;
  font-size: 18px;
  color: #404040;
  line-height: 30px;
}

.main-item-title {
  font-weight: bold;
  font-size: 24px;
  color: #091221;
  line-height: 1;
}

.main-item img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.main-item-box {
  z-index: 1;
  position: relative;
  margin-top: 158px;
  margin-left: 25px;
}

.title-min {
  font-weight: 400;
  font-size: 24px;
  color: #404040;
  line-height: 1;
  margin: 30px 30px 60px;
}

.part-two {
  margin-top: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.title {
  text-align: center;
}

.bottom {
  margin-top: 50px;
  display: flex;
}

.bottom-img {
  /* background-color: #f8fafd; */
  border-radius: 10px;
}

.bottom-img img {
  height: 425px;
}

.tap {
  margin-left: 10px;
}

.tap-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 19px;
  cursor: pointer;
}

.is-actives {
  background: linear-gradient(to right, #203DF5, #3E85FF) !important;
}

.color-is-active {
  color: #ffffff !important;
}
</style>